var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 285,
    height: 136.967,
    viewBox: "0 0 285 136.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27483",
    "data-name": "Group 27483",
    transform: "translate(-577.001 -224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27471",
    "data-name": "Group 27471",
    transform: "translate(576.818 224.436)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17487",
    "data-name": "Rectangle 17487",
    width: 285,
    height: 117,
    rx: 10,
    transform: "translate(0.183 -0.436)",
    fill: "#e5f3f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27041",
    "data-name": "Group 27041",
    transform: "translate(8.816 9.641)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7598",
    "data-name": "Rectangle 7598",
    width: 267.656,
    height: 96.768,
    rx: 5,
    transform: "translate(0.011 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28503",
    "data-name": "Path 28503",
    d: "M11452.5-5253.115h267.282",
    transform: "translate(-11452.235 5272.298)",
    fill: "none",
    stroke: "rgba(6,35,61,0.5)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3556",
    "data-name": "Group 3556",
    transform: "translate(5.478 26.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3405",
    "data-name": "Group 3405",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_640",
    "data-name": "Ellipse 640",
    cx: 2.183,
    cy: 2.183,
    rx: 2.183,
    ry: 2.183,
    fill: "none",
    stroke: "#ea555f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_569",
    "data-name": "Line 569",
    x2: 3.998,
    transform: "translate(0.143 1.51)",
    fill: "none",
    stroke: "#ea555f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_570",
    "data-name": "Line 570",
    x2: 3.998,
    transform: "translate(0.143 2.939)",
    fill: "none",
    stroke: "#ea555f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11342",
    "data-name": "Path 11342",
    d: "M9.536,3a4.046,4.046,0,0,0,0,4.284",
    transform: "translate(-7.513 -2.917)",
    fill: "none",
    stroke: "#ea555f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11343",
    "data-name": "Path 11343",
    d: "M12.5,3a4.046,4.046,0,0,1,0,4.284",
    transform: "translate(-10.239 -2.917)",
    fill: "none",
    stroke: "#ea555f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11507",
    "data-name": "Path 11507",
    d: "M0,1.22,1.2,0,2.49,1.22",
    transform: "translate(41.697 2.915) rotate(180)",
    fill: "none",
    stroke: "#ea555f",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4650",
    "data-name": "Group 4650",
    transform: "translate(5.478 5.598)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_935",
    "data-name": "Ellipse 935",
    cx: 4.172,
    cy: 4.172,
    rx: 4.172,
    ry: 4.172,
    transform: "translate(0 0)",
    fill: "#e5f3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11507-2",
    "data-name": "Path 11507",
    d: "M0,1.22.916.287,1.2,0l.5.472.793.748",
    transform: "translate(5.489 5.002) rotate(180)",
    fill: "none",
    stroke: "#06233d",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27478",
    "data-name": "Group 27478",
    transform: "translate(-7.599 -1.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11804",
    "data-name": "Group 11804",
    transform: "translate(238.17 24.346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2431",
    "data-name": "Rectangle 2431",
    width: 31.736,
    height: 12.563,
    rx: 6.281,
    transform: "translate(0 0)",
    fill: "#ea555f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49160",
    "data-name": "Path 49160",
    d: "M-24.876-9.3V-7.83h-.687v-3.952h1.512A1.53,1.53,0,0,1-23-11.438a1.159,1.159,0,0,1,.39.912,1.12,1.12,0,0,1-.381.9,1.6,1.6,0,0,1-1.068.323Zm0-.551h.825a.813.813,0,0,0,.559-.172.633.633,0,0,0,.193-.5.684.684,0,0,0-.2-.512.753.753,0,0,0-.537-.2h-.844Zm4.582,1.732a1.023,1.023,0,0,1-.825.342.912.912,0,0,1-.723-.28,1.189,1.189,0,0,1-.246-.809v-1.9h.66v1.895q0,.559.464.559a.652.652,0,0,0,.649-.345v-2.109h.66V-7.83h-.622Zm3.887-1.151a1.764,1.764,0,0,1-.305,1.089,1,1,0,0,1-.84.4.958.958,0,0,1-.8-.372l-.033.318h-.6V-12h.66v1.515a.955.955,0,0,1,.768-.337,1.006,1.006,0,0,1,.844.4,1.794,1.794,0,0,1,.307,1.116Zm-.66-.057a1.247,1.247,0,0,0-.168-.717.56.56,0,0,0-.489-.239.612.612,0,0,0-.6.375V-8.7a.619.619,0,0,0,.608.383.556.556,0,0,0,.478-.231,1.208,1.208,0,0,0,.174-.7Zm1.914,1.5h-.66V-12h.66Zm1.42,0h-.66v-2.937h.66Zm-.7-3.7a.35.35,0,0,1,.1-.252.364.364,0,0,1,.276-.1.369.369,0,0,1,.277.1.347.347,0,0,1,.1.252.339.339,0,0,1-.1.248.371.371,0,0,1-.277.1.367.367,0,0,1-.276-.1A.342.342,0,0,1-14.433-11.53Zm3.065,2.9a.3.3,0,0,0-.145-.269A1.544,1.544,0,0,0-12-9.06a2.477,2.477,0,0,1-.562-.179.75.75,0,0,1-.494-.692.782.782,0,0,1,.32-.635,1.266,1.266,0,0,1,.814-.255,1.318,1.318,0,0,1,.851.261.827.827,0,0,1,.324.676h-.66a.407.407,0,0,0-.141-.316.541.541,0,0,0-.375-.126.585.585,0,0,0-.354.1.317.317,0,0,0-.137.269.267.267,0,0,0,.128.236,1.754,1.754,0,0,0,.516.17,2.441,2.441,0,0,1,.609.2.863.863,0,0,1,.328.284.723.723,0,0,1,.107.4.765.765,0,0,1-.328.642,1.4,1.4,0,0,1-.861.246,1.519,1.519,0,0,1-.643-.13,1.059,1.059,0,0,1-.44-.358.848.848,0,0,1-.157-.491h.641a.465.465,0,0,0,.176.36.686.686,0,0,0,.432.126.667.667,0,0,0,.4-.1A.307.307,0,0,0-11.368-8.629ZM-9.5-10.447a1.032,1.032,0,0,1,.817-.375q.939,0,.953,1.072V-7.83h-.66V-9.725a.58.58,0,0,0-.132-.43.538.538,0,0,0-.387-.126.635.635,0,0,0-.592.353v2.1h-.66V-12h.66Z",
    transform: "translate(270.684 40.515)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12552",
    "data-name": "Group 12552",
    transform: "translate(5.544 39.117)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_672",
    "data-name": "Line 672",
    y2: 4.214,
    transform: "translate(46.994 20.229)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7664",
    "data-name": "Rectangle 7664",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.47)",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256.764,
    height: 52.455,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 256.464,
    height: 52.155,
    rx: 4.85,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7663",
    "data-name": "Rectangle 7663",
    width: 99.277,
    height: 33.377,
    rx: 3,
    transform: "translate(5.341 5.362)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439",
    "data-name": "Group 12439",
    transform: "translate(10.561 10.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12321",
    "data-name": "Group 12321",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3743",
    "data-name": "Group 3743"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_665",
    "data-name": "Line 665",
    fill: "none",
    stroke: "#82909d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_666",
    "data-name": "Line 666",
    y2: 0.005,
    transform: "translate(1.46 0.013)",
    fill: "none",
    stroke: "#82909d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_669",
    "data-name": "Line 669",
    y2: 0.005,
    transform: "translate(0 1.473)",
    fill: "none",
    stroke: "#82909d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_670",
    "data-name": "Line 670",
    y2: 0.005,
    transform: "translate(0 3.04)",
    fill: "none",
    stroke: "#82909d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_673",
    "data-name": "Line 673",
    y2: 0.005,
    transform: "translate(1.46 1.473)",
    fill: "none",
    stroke: "#82909d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_674",
    "data-name": "Line 674",
    y2: 0.005,
    transform: "translate(1.46 3.04)",
    fill: "none",
    stroke: "#82909d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50396",
    "data-name": "Path 50396",
    d: "M0,0H7.825V2.846H0Z",
    transform: "translate(3.719 0.026)",
    fill: "rgba(6,35,61,0.5)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7599",
    "data-name": "Rectangle 7599",
    width: 88.659,
    height: 18.514,
    rx: 3,
    transform: "translate(0 5.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50397",
    "data-name": "Path 50397",
    d: "M0,0H78.608V2.846H0Z",
    transform: "translate(5.142 11.053)",
    fill: "rgba(6,35,61,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50398",
    "data-name": "Path 50398",
    d: "M0,0H65.472V2.846H0Z",
    transform: "translate(5.142 17.099)",
    fill: "rgba(6,35,61,0.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12493",
    "data-name": "Group 12493",
    transform: "translate(6.588 43.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3708",
    "data-name": "Group 3708",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M2.414,2.414,0,0",
    transform: "translate(0 1.707) rotate(-45)",
    fill: "none",
    stroke: "#009081",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11595",
    "data-name": "Path 11595",
    d: "M2.415,2.415,0,0",
    transform: "translate(1.707 3.415) rotate(-135)",
    fill: "none",
    stroke: "#009081",
    strokeLinecap: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50399",
    "data-name": "Path 50399",
    d: "M0,0H20.887V2.846H0Z",
    transform: "translate(5.914 0.284)",
    fill: "#009081"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29659",
    "data-name": "Path 29659",
    d: "M1.814,0V96.768A1.791,1.791,0,0,1,0,94.787V1.893A1.8,1.8,0,0,1,1.814,0Z",
    transform: "translate(0.007 0)",
    fill: "#bfccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18106",
    "data-name": "Rectangle 18106",
    width: 54,
    height: 3,
    transform: "translate(17.368 8.673)",
    fill: "rgba(6,35,61,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50395",
    "data-name": "Path 50395",
    d: "M0,0H31.3V2.846H0Z",
    transform: "translate(11.998 27.651)",
    fill: "#ea555f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27477",
    "data-name": "Group 27477",
    transform: "translate(743.24 262.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27476",
    "data-name": "Group 27476",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27475",
    "data-name": "Group 27475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50445",
    "data-name": "Path 50445",
    d: "M45.293,254.346,56.9,272.661l-5.958,3.776L39.335,258.122c-.34-.537.724-1.828,2.363-2.866a8.3,8.3,0,0,1,2.282-1.044c.656-.169,1.142-.134,1.313.135",
    transform: "translate(21.56 -207.797)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50446",
    "data-name": "Path 50446",
    d: "M99.345,239.574a5.843,5.843,0,1,1-5.84-5.646,5.746,5.746,0,0,1,5.84,5.646",
    transform: "translate(-29.704 -191.295)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50447",
    "data-name": "Path 50447",
    d: "M9.214,21.572,7.017,0A33.721,33.721,0,0,1,3.531.537,33.879,33.879,0,0,1,0,.715L2.2,22.286c.065.632,1.7.989,3.629.793a8.3,8.3,0,0,0,2.44-.59c.62-.273.981-.6.949-.917",
    transform: "translate(83.176 86.08) rotate(173)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50448",
    "data-name": "Path 50448",
    d: "M41.323,342.285a5.078,5.078,0,1,0-6.58-2.558,4.993,4.993,0,0,0,6.58,2.558",
    transform: "translate(35.235 -272.006)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50449",
    "data-name": "Path 50449",
    d: "M3.891,11.659A7.565,7.565,0,0,0,15.526,4.526L15.059,0,11.8.336l.467,4.526a4.289,4.289,0,1,1-8.533.88L3.263,1.217,0,1.553.467,6.08a7.558,7.558,0,0,0,3.424,5.579",
    transform: "translate(89.881 96.978) rotate(173)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50450",
    "data-name": "Path 50450",
    d: "M280.947,250,263.788,263.26l4.313,5.582,17.159-13.256c.5-.389-.057-1.965-1.243-3.5a8.3,8.3,0,0,0-1.789-1.76c-.559-.382-1.028-.516-1.28-.321",
    transform: "translate(-247.9 -204.368)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50451",
    "data-name": "Path 50451",
    d: "M244.359,237.606a5.843,5.843,0,1,0,7.416-3.315,5.746,5.746,0,0,0-7.416,3.315",
    transform: "translate(-214.523 -191.295)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50452",
    "data-name": "Path 50452",
    d: "M366.6,239.351l-6.982-20.528a34.411,34.411,0,0,1-6.678,2.271l6.982,20.528c.2.6,1.878.582,3.715-.042a8.3,8.3,0,0,0,2.245-1.122c.543-.405.821-.805.719-1.107",
    transform: "translate(-345.331 -178.943)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50453",
    "data-name": "Path 50453",
    d: "M345.978,307.492a5.078,5.078,0,1,0,6.986,1.016,4.994,4.994,0,0,0-6.986-1.016",
    transform: "translate(-331.148 -250.636)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50454",
    "data-name": "Path 50454",
    d: "M386.937,167.136a7.566,7.566,0,0,0,9.737-9.561l-1.471-4.306-3.1,1.06,1.471,4.306a4.289,4.289,0,1,1-8.117,2.773l-1.471-4.306-3.1,1.06,1.471,4.306a7.558,7.558,0,0,0,4.589,4.668",
    transform: "translate(-380.878 -125.336)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18128",
    "data-name": "Rectangle 18128",
    width: 12.143,
    height: 9.888,
    transform: "translate(43.05 35.29)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18129",
    "data-name": "Rectangle 18129",
    width: 12.143,
    height: 2.987,
    transform: "translate(43.05 42.192)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18130",
    "data-name": "Rectangle 18130",
    width: 12.143,
    height: 4.497,
    transform: "translate(43.05 35.29)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50455",
    "data-name": "Path 50455",
    d: "M141.178,263.653h11.553a6.121,6.121,0,0,1,6.1,6.1V277.9a6.121,6.121,0,0,1-6.1,6.1H141.178a6.121,6.121,0,0,1-6.1-6.1v-8.144a6.121,6.121,0,0,1,6.1-6.1",
    transform: "translate(-97.833 -215.602)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50456",
    "data-name": "Path 50456",
    d: "M130.733,284.627h1.524a14.506,14.506,0,0,0,14.506-14.506V251.059a7.126,7.126,0,0,0-7.126-7.126H123.353a7.126,7.126,0,0,0-7.126,7.126v19.061a14.507,14.507,0,0,0,14.506,14.506",
    transform: "translate(-82.327 -199.476)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50457",
    "data-name": "Path 50457",
    d: "M153.3,301h2.714a8.633,8.633,0,0,0,8.633-8.633V277.54a3.455,3.455,0,0,0-3.456-3.455H148.119a3.455,3.455,0,0,0-3.455,3.455v14.831A8.633,8.633,0,0,0,153.3,301",
    transform: "translate(-105.39 -224.132)",
    fill: "#343849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50458",
    "data-name": "Path 50458",
    d: "M196.377,23.482h.574a.568.568,0,0,0,.568-.568V15.006a.568.568,0,0,0-.568-.568h-.574a.568.568,0,0,0-.568.568v7.908a.568.568,0,0,0,.568.568",
    transform: "translate(-147.587 -11.807)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50459",
    "data-name": "Path 50459",
    d: "M189.41,2.021A2.022,2.022,0,1,0,191.432,0a2.022,2.022,0,0,0-2.022,2.022",
    transform: "translate(-142.354 0.001)",
    fill: "#e75660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50460",
    "data-name": "Path 50460",
    d: "M93.51,55.441V50.559a6.748,6.748,0,0,1,6.748-6.748h21.375a6.749,6.749,0,0,1,6.748,6.748v4.882a2.964,2.964,0,0,1,2.523,2.931v5.976a2.964,2.964,0,0,1-2.523,2.931v1.917a4.529,4.529,0,0,1-4.529,4.529H98.04a4.529,4.529,0,0,1-4.529-4.529V67.278a2.964,2.964,0,0,1-2.523-2.931V58.372a2.964,2.964,0,0,1,2.523-2.931",
    transform: "translate(-61.869 -35.826)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50461",
    "data-name": "Path 50461",
    d: "M122.5,87.6h20.659a4.753,4.753,0,0,0,4.753-4.753V76.207a4.753,4.753,0,0,0-4.753-4.753H122.5a4.753,4.753,0,0,0-4.753,4.753v6.639A4.753,4.753,0,0,0,122.5,87.6",
    transform: "translate(-83.749 -58.431)",
    fill: "#333949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14424",
    "data-name": "Path 14424",
    d: "M140.432,87.443a5.364,5.364,0,1,0,5.364,5.364A5.37,5.37,0,0,0,140.432,87.443Zm0,8.521a3.157,3.157,0,1,1,3.157-3.157A3.16,3.16,0,0,1,140.432,95.964Z",
    transform: "translate(-84.51 -71.79)",
    fill: "#35a398"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14425",
    "data-name": "Path 14425",
    d: "M216.542,87.443a5.364,5.364,0,1,0,5.364,5.364A5.37,5.37,0,0,0,216.542,87.443Zm0,8.521a3.157,3.157,0,1,1,3.157-3.157A3.16,3.16,0,0,1,216.542,95.964Z",
    transform: "translate(-174.491 -71.79)",
    fill: "#35a398"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50462",
    "data-name": "Path 50462",
    d: "M79.061,119h1.575a3.118,3.118,0,0,0,3.119-3.119v-5.715a3.119,3.119,0,0,0-3.119-3.119H79.061Z",
    transform: "translate(-12.545 -87.535)",
    fill: "#333949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50463",
    "data-name": "Path 50463",
    d: "M300.9,119h-1.575a3.118,3.118,0,0,1-3.119-3.119v-5.715a3.119,3.119,0,0,1,3.119-3.119H300.9Z",
    transform: "translate(-269.267 -87.535)",
    fill: "#333949"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_50464",
    "data-name": "Path 50464",
    d: "M0,31c0,2.363,2.4,4.279,5.363,4.279S10.726,33.363,10.726,31Z",
    transform: "translate(43.679 0.713)",
    fill: "#ea555f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistant);
export default __webpack_public_path__ + "static/media/AIAssistant.b3df9f73e31b3b4e5dd544ac7cc93f63.svg";
export { ForwardRef as ReactComponent };